import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiActivity, FiArrowLeft } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import LanguageSwitcher from '../ui/LanguageSwitcher';

export default function ManageHeader({ merchant, token, showBack = false, backLabel }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();
  const { getMerchantTranslation } = useLanguage();
  const [logoError, setLogoError] = useState(false);

  const logoUrl = merchant?.logo_url;
  const logoWidth = merchant?.logo_width || 40;
  const hasValidLogo = logoUrl && !logoError;
  const translations = merchant?.merchant_translations || [];

  const businessName = getMerchantTranslation(
    merchant?.business_name,
    translations,
    'business_name'
  );

  const handleBack = () => {
    navigate(`/b/${token}`);
  };

  return (
    <>
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:block focus:bg-white focus:text-gray-900 focus:font-medium focus:shadow-md focus:rounded-lg focus:z-50 focus:m-2"
    >
      {t('manage.skipToContent', 'Skip to main content')}
    </a>
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-40">
      <div className="max-w-3xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            {showBack && (
              <button
                onClick={handleBack}
                className="p-2 -ml-2 rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0"
                aria-label={t('manage.backToOverview', 'Back to booking overview')}
              >
                <SafeIcon icon={FiArrowLeft} className="w-5 h-5 text-gray-600" />
              </button>
            )}

            {hasValidLogo ? (
              <div
                className="flex items-center justify-center flex-shrink-0"
                style={{ width: `${logoWidth}px`, maxHeight: '60px' }}
              >
                <img
                  src={logoUrl}
                  alt={merchant?.display_name || merchant?.business_name || 'Logo'}
                  className="object-contain"
                  style={{ width: `${logoWidth}px`, height: 'auto', maxHeight: '60px' }}
                  onError={() => setLogoError(true)}
                />
              </div>
            ) : (
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: theme.colors.primary.gradient }}
              >
                <SafeIcon
                  icon={FiActivity}
                  className="w-5 h-5"
                  style={{ color: theme.colors.primary.contrastIcon }}
                />
              </div>
            )}

            <div className="text-left min-w-0">
              {merchant?.display_name && (
                <div className="text-lg font-bold text-gray-900 truncate">
                  {merchant.display_name}
                </div>
              )}
              {businessName && !merchant?.display_name && (
                <div className="text-lg font-bold text-gray-900 truncate">
                  {businessName}
                </div>
              )}
            </div>
          </div>

          <div className="flex-shrink-0">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </header>
    </>
  );
}
